export function normalizeUrl(url: string) {
    try {
        const urlObj = new URL(url, window.location.href);
        const host = urlObj.host;

        // Check if host ends with mark43 domains
        const isMark43Domain = /\.(mark43\.com|mark43\.us|mark43\.io)$/.test(host);

        // Replace numeric path segments
        let normalizedUrl = urlObj.pathname.replace(/\/(\d+)\/?/g, '/*/');
        // Remove trailing slash if present
        normalizedUrl = normalizedUrl.replace(/\/$/, '');
        // Remove the query string entirely
        normalizedUrl = normalizedUrl.replace(/\?.*$/, '');

        // Add host if it's not a mark43 domain
        if (!isMark43Domain) {
            normalizedUrl = `${host}${normalizedUrl}`;
        }

        return normalizedUrl;
    } catch (e) {
        // If URL parsing fails, fall back to original behavior
        let normalizedUrl = url.replace(/\/(\d+)\/?/g, '/*/');
        normalizedUrl = normalizedUrl.replace(/\/$/, '');
        normalizedUrl = normalizedUrl.replace(/\?.*$/, '');
        return normalizedUrl;
    }
}
